var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcEdit2 = function SvgIcEdit2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#212221",
    d: "M15.36 13.575H.64c-.354 0-.64.268-.64.6v.675c0 .082.072.15.16.15h15.68c.088 0 .16-.068.16-.15v-.675c0-.332-.286-.6-.64-.6M2.914 12a1 1 0 0 0 .12-.01l3.364-.553a.2.2 0 0 0 .106-.052l8.478-7.948a.19.19 0 0 0 .059-.132.18.18 0 0 0-.059-.133L11.658.054A.2.2 0 0 0 11.516 0a.2.2 0 0 0-.142.054L2.896 8.002a.2.2 0 0 0-.056.1l-.59 3.154a.6.6 0 0 0 .02.3c.033.098.09.187.168.258.132.12.298.186.476.186"
  })));
};
export default SvgIcEdit2;